var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.09,
    height: 10.173,
    viewBox: "0 0 15.09 10.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(-563.219 -1212.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M570.42,1222.055h-1.286a.939.939,0,0,0,.019,1.869h4.22a.939.939,0,0,0-.019-1.869h-1.268v-.706H570.42Z",
    transform: "translate(-0.489 -0.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M571.86,1214.809h2.573v1.386a.886.886,0,0,0,.818.928h.052a.883.883,0,0,0,.8-.918v-2.33a.891.891,0,0,0-.839-.934h-8.473a.885.885,0,0,0-.834.924v2.331a.886.886,0,0,0,.818.928h.052a.884.884,0,0,0,.8-.919v-1.4h2.572v2.314h1.666Z",
    transform: "translate(-0.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M578.246,1219.061a.8.8,0,0,0-.741-.492H564.022a.8.8,0,0,0,0,1.609H577.5a.8.8,0,0,0,.742-1.117Z",
    transform: "translate(0 -0.543)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleNoText);
export default __webpack_public_path__ + "static/media/toggle-no-text.8e9d26dfd96f3f7dfe7229216e86e0f4.svg";
export { ForwardRef as ReactComponent };